import { gql } from '@apollo/client';

export const getAttributeLevelSales = gql`
    query getGrowthAnalysisData(
        $timePeriod: [JSONString]!
        $aggPeriod: String!
        $frequency: String!
        $featureName: String!
        $dimension: SamyaString!
        $attributeType: SamyaString!
        $filters: JSONString!
        $lagList: [Int]!
        $limit: Int
        $offset: Int!
        $metricType: SamyaString
        $comparisonPeriodType: String!
    ) {
        getGrowthAnalysisData(
            timePeriod: $timePeriod
            aggPeriod: $aggPeriod
            frequency: $frequency
            dimension: $dimension
            attributeType: $attributeType
            filters: $filters
            featureName: $featureName
            lagList: $lagList
            limit: $limit
            offset: $offset
            metricType: $metricType
            comparisonPeriodType: $comparisonPeriodType
        ) {
            data {
                attributeType
                graphData {
                    lag
                    salesData
                    baseData
                    promoData
                    noPromoData
                    incrementalData
                }
                additionalData {
                    sales {
                        labelName
                        value
                    }
                    incremental {
                        labelName
                        value
                    }
                    promo {
                        labelName
                        value
                    }
                }
            }
            comparisonTimePeriod {
                startTimestamp
                endTimestamp
            }
            meta {
                count
                __typename
            }
        }
    }
`;

export const getTotalSales = gql`
    query getTotalSales($timePeriod: JSONString!, $filters: JSONString!, $lagList: [Int]!) {
        getTotalSales(timePeriod: $timePeriod, filters: $filters, lagList: $lagList) {
            totalSalesData {
                lag
                salesValue
                salesVolume
                promoValue
                noPromoValue
                promoVolume
                noPromoVolume
                baseValue
                baseVolume
                incrementalValue
                incrementalVolume
            }
        }
    }
`;

export const getSalesAttribute = gql`
    query getSalesAttributionFeatureGroupLevel(
        $filter: JSONString
        $aggPeriod: String!
        $featureName: String!
        $frequency: String!
        $timePeriod: [JSONString!]!
        $contributionType: SamyaString
        $comparisonPeriodType: String!
    ) {
        getSalesAttributionFeatureGroupLevel(
            timePeriod: $timePeriod
            aggPeriod: $aggPeriod
            frequency: $frequency
            contributionType: $contributionType
            filters: $filter
            featureName: $featureName
            comparisonPeriodType: $comparisonPeriodType
        ) {
            contributionType
            featureGroupLevelData {
                totalSalesData {
                    lag
                    value
                    label
                }
                featureGroups {
                    groupName
                    groupValue
                }
            }
        }
    }
`;

export const getProfitPoolData = gql`
    query getSalesAttributionProfit($filter: JSONString, $timePeriod: JSONString!, $aggPeriod: String!) {
        getSalesAttributionProfit(timePeriod: $timePeriod, aggPeriod: $aggPeriod, filters: $filter) {
            totalSalesData {
                lag
                value
                label
            }
            featureGroups {
                groupName
                features {
                    featureName
                    value
                }
            }
        }
    }
`;

export const getTrendsChartData = gql`
    query getAttributeTrendChartData(
        $timePeriod: [JSONString!]!
        $attributionField: SamyaString!
        $dimension: SamyaString!
        $frequency: String!
        $featureName: String!
        $attributeType: SamyaString!
        $contributionType: SamyaString!
        $limit: Int!
        $offset: Int!
        $filters: JSONString!
        $comparisonPeriodType: String!
    ) {
        getAttributeTrendChartData(
            timePeriod: $timePeriod
            attributionField: $attributionField
            dimension: $dimension
            frequency: $frequency
            attributeType: $attributeType
            contributionType: $contributionType
            limit: $limit
            offset: $offset
            filters: $filters
            featureName: $featureName
            comparisonPeriodType: $comparisonPeriodType
        ) {
            data {
                attributeName
                startTimestamp
                periodLabel
                attributionValue
                salesCurrent
                salesPrevious
            }
            meta {
                count
            }
        }
    }
`;

export const getSalesAttributionFeatureLevelData = gql`
    query getSalesAttributionFeatureLevel(
        $featureGroupName: SamyaString
        $filter: JSONString
        $aggPeriod: String!
        $featureName: String!
        $frequency: String!
        $timePeriod: [JSONString!]!
        $contributionType: SamyaString
        $lagList: [Int]!
        $comparisonPeriodType: String!
    ) {
        getSalesAttributionFeatureLevel(
            featureGroupName: $featureGroupName
            timePeriod: $timePeriod
            aggPeriod: $aggPeriod
            frequency: $frequency
            contributionType: $contributionType
            filters: $filter
            lagList: $lagList
            featureName: $featureName
            comparisonPeriodType: $comparisonPeriodType
        ) {
            contributionType
            featureGroupName
            featureLevelData {
                featureName
                featureValue
                __typename
            }
            __typename
        }
        __typename
    }
`;

export const getAttributionFeatureDimensionLevel = gql`
    query getSalesAttributionFeatureDimensionLevel(
        $featureGroupName: SamyaString!
        $attributeFeatureName: SamyaString!
        $dimension: SamyaString!
        $aggPeriod: String!
        $frequency: String!
        $lagList: [Int]!
        $attributeType: SamyaString!
        $filter: JSONString
        $featureName: String!
        $timePeriod: [JSONString!]!
        $contributionType: SamyaString
        $limit: Int
        $offset: Int!
        $comparisonPeriodType: String!
    ) {
        getSalesAttributionFeatureDimensionLevel(
            featureGroupName: $featureGroupName
            attributeFeatureName: $attributeFeatureName
            dimension: $dimension
            attributeType: $attributeType
            timePeriod: $timePeriod
            aggPeriod: $aggPeriod
            frequency: $frequency
            contributionType: $contributionType
            filters: $filter
            lagList: $lagList
            limit: $limit
            offset: $offset
            featureName: $featureName
            comparisonPeriodType: $comparisonPeriodType
        ) {
            contributionType
            featureGroupName
            featureName
            attributeType
            featureDimensionLevelData {
                attributeName
                attributeValue
                competitorData {
                    attributeName
                    attributeValue
                }
            }
            count
        }
        __typename
    }
`;
